module.exports = __webpack_public_path__ + "assets/img/theX-header.5377b123.png";